export default function pointsStandingsLookup(type: number): { tour: number, division: number, class: string } {
  const pointsStandingsTournamentData = {
    91: { tour: 9, division: 0, class: 'anglers' },
    90: { tour: 9, division: 0, class: 'anglers' },
    99: { tour: 35, division: 0, class: 'anglers' },
    501: { tour: 5, division: 0, class: 'anglers' },
    531: { tour: 5, division: 3, class: 'anglers' },
    551: { tour: 5, division: 5, class: 'anglers' },
    511: { tour: 5, division: 1, class: 'anglers' },
    510: { tour: 5, division: 1, class: 'coanglers' },
    530: { tour: 5, division: 3, class: 'coanglers' },
    550: { tour: 5, division: 5, class: 'coanglers' },
    521: { tour: 5, division: 2, class: 'anglers' },
    520: { tour: 5, division: 2, class: 'coanglers' },
    1190: { tour: 5, division: 69, class: 'coanglers' },
    1191: { tour: 5, division: 69, class: 'anglers' },
    1200: { tour: 5, division: 70, class: 'coanglers' },
    1201: { tour: 5, division: 70, class: 'anglers' },
    1210: { tour: 5, division: 71, class: 'coanglers' },
    1211: { tour: 5, division: 71, class: 'anglers' },
  };
  return pointsStandingsTournamentData.hasOwnProperty(type) ? pointsStandingsTournamentData[type] : {};
};
